var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"headerBarWrapper",class:_vm.$style.wrapper,attrs:{"data-name":"header-bar-wrapper"}},[_c('div',{class:_vm.$style['icon-container'],attrs:{"id":"headerLogo"}},[_c('logo',{class:_vm.$style.logo,attrs:{"ns":'header'}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a5a5d36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderBar.vue
// module id = null
// module chunks = 